module.exports = __webpack_public_path__ + "static/media/cat-transparent.be16f240.png";